import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TOAST_CONFIG, ToastrModule } from 'ngx-toastr';
import { UpdateWorkerComponent } from './shared/components';
import { NgxSpinnerModule } from 'ngx-spinner';
import { WebServiceWorker } from './services';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    NgxSpinnerModule,
    UpdateWorkerComponent,
    ToastrModule,
  ],
  providers: [
    UpdateWorkerComponent,
    {
      provide: TOAST_CONFIG,
      useValue: {
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
      },
    },
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  private webServiceWorker = inject(WebServiceWorker);
  public title = 'corp-centralizacion';
  public isNewAppVersionAvailable: boolean = false;
  public newAppUpdateAvailableSubscription: any;

  ngOnInit(): void {
    this.checkIfAppUpdated();
  }

  checkIfAppUpdated() {
    this.newAppUpdateAvailableSubscription =
      this.webServiceWorker.$isAnyNewUpdateAvailable.subscribe(
        (versionAvailableFlag: boolean) => {
          console.log(
            'isNewAppVersionAvailable: ',
            this.isNewAppVersionAvailable,
          );
          this.isNewAppVersionAvailable = versionAvailableFlag;
        },
      );
  }

  refreshApp() {
    this.webServiceWorker.swUpdate
      .activateUpdate()
      .then(() => document.location.reload());
  }

  ngOnDestroy() {
    if (this.newAppUpdateAvailableSubscription) {
      this.newAppUpdateAvailableSubscription.unsubscribe();
    }
  }
}
